import Vue from 'vue';
import skeleton from 'tb-skeleton';
import 'tb-skeleton/dist/skeleton.css';

Vue.use(skeleton);
